import app from 'flarum/common/app';
import { extend } from 'flarum/common/extend';

/**
 * Staff «Редактировать» user window (core EditUserModal, forum and admin): our login and
 * password rules as one-line hints under «Логин» and «Пароль» (the server checks them).
 */
export default function extendEditUserHints() {
  extend('flarum/common/components/EditUserModal', 'fields', function (items) {
    const hint = key => m("p", {
      className: "helpText Ppk2EditUserHint"
    }, app.translator.trans('ppk2-profile.lib.rules.' + key));
    if (items.has('username')) {
      items.add('ppk2UsernameHint', hint('login.hint'), items.getPriority('username') - 0.5);
    }
    if (items.has('password') && this.setPassword && this.setPassword()) {
      items.add('ppk2PasswordHint', hint('password.hint'), items.getPriority('password') - 0.5);
    }
  });
}
flarum.reg.add('ppk2-profile', 'common/editUserHints', extendEditUserHints);